/**
 * Module dependencies
 */
const React = require('react');
const ReactDOM = require('react-dom');

const TrackCookies = require('../../pages/trackCookies/components/TrackCookies');

/**
 * Get server state
 */
const {
  site,
  siteId,
  cookiesData,
  trackId,
} = window.__PRELOADED_STATE__; // eslint-disable-line no-underscore-dangle

ReactDOM.hydrate(
  <TrackCookies
    site={site}
    siteId={siteId}
    cookiesData={cookiesData}
    trackId={trackId}
  />,
  document.getElementById('root-app'),
);
